/**
 * Route for `advertiser-sub-users`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserSubUsersPage } from "../features/advertiser-sub-users/AdvertiserSubUsersPage";

export const advertiserSubUsersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-sub-users",
	component: AdvertiserSubUsersPage,
});

export default advertiserSubUsersRoute;
